<template>
    <div class="mainpage">
        <h2>shipment</h2>

        <div class="home">
            <div v-if="!validWorker" class="form">
                <div>Worker:</div>
                <input ref="wrkr" type="text" v-model="wrkr" placeholder="scan Worker QR code" class="inp big"
                       @keypress.enter="validateWorker"/>
            </div>
            <div v-else class="c">
                <div class="flx" @click="invalidateWorker">
                    <refresh-icon/>
                </div>
                Current worker: <b>{{ validWorker }}</b>
            </div>
        </div>

        <div class="home" v-if="validWorker">
            <div v-if="!validSO.rows" class="form">
                <div>Scan SO:</div>
                <input ref="sofld" type="text" v-model="tmpSO" class="inp big" @keypress.enter="scanSO"/>
            </div>
            <div v-else class="c">
                <div class="flx" @click="invalidateSO">
                    <refresh-icon/>
                </div>
                SO: <b>{{ validSO.so }}</b>
                <span v-if="validSO.customerName"> | <b>{{ validSO.customerName }}</b></span>
                <span v-if="validSO.force_customerSN"><br><b style="color:red">CUSTOMER HAS OWN SERIAL NUMBERS!</b></span>
            </div>
        </div>

        <div class="home" v-if="validWorker && validSO.so">
            <div class="form">
                <div>Scan SN:</div>
                <input ref="snfld" type="text" v-model="tmpSN" class="inp big" @keypress.enter="scanSN"/>
            </div>
            <div class="c" v-if="lastShipState">Last scan: <b v-text="lastShipState.sn"></b>,
                itemCode: <b v-text="lastShipState.itemCode"></b>,
                shipped qtty: <b v-text="lastShipState.count"></b>
                <span v-if="lastShipState.csn">, customer SN: <b>{{lastShipState.csn}}</b></span></div>
        </div>

        <div class="home" v-if="validSO.rows">
            <h4>All items needed for this Sales Order:</h4>
            <table class="snlist">
                <thead>
                <tr>
                    <th>Item Code</th>
                    <th>Ordered</th>
                    <th>Sh. ERP</th>
                    <th>Sh. S/N</th>
                    <th>Remains</th>
                </tr>
                </thead>
                <tr v-for="item in validSO.rows" :class="{ 'disabled': item.trackSN===0, 'rowdone': remains(item)==0 }">
                    <td><span v-text="item.itemCode" class="sn"></span></td>
                    <td class="c" v-text="item.qtty"></td>
                    <td class="c" v-text="item.qttyERP" :class="{'nula':item.qttyERP==0}"></td>
                    <td class="c" v-text="item.trackSN===1 ? doneToInt(item.itemCode):'-'"
                        :class="{'notdone':remains(item) }"></td>
                    <td class="c" v-text="remains(item)"></td>
                </tr>
            </table>
        </div>
        <div v-if="lastShipState && lastShipState.force_customerSN && !lastShipState.csn">
            <div class="popup-bg"></div>
            <div class="popup">
                <div @click="closeCSN" class="fr"><close-icon class="s2x" ></close-icon></div>
                <h3 class="c">Scan Customer's Serial Number:</h3>
                <p class="c" style="padding: 0 10%"><input ref="sn2fld" type="text" v-model="CSN" class="inp big" @keypress.enter="scanCSN"/></p>
            </div>
        </div>

        <error-dialog v-if="errorDialog" :msg="errorDialog.msg"></error-dialog>
    </div>
</template>

<script>
    import debounce from '@/debounce';
    import {mapState} from 'vuex'
    import RefreshIcon from "vue-material-design-icons/refresh"
    import CloseIcon from "vue-material-design-icons/close"
    import Vue from 'vue'
    import ErrorDialog from "@/components/ErrorDialog";

    export default {
        name: "Shipment",
        components: {
            ErrorDialog, RefreshIcon, CloseIcon
        },
        computed: {
            ...mapState(['validWorker', 'validSO', 'lastResult', 'lastShipState', 'errorDialog']),
        },
        data() {
            return {
                wrkr: '',
                tmpSO: '',
                tmpSN: '',
                CSN: ''
            }
        },
        updated() {
            if (this.$refs.sn2fld)
                this.$refs.sn2fld.focus();
            else if (this.$refs.snfld)
                this.$refs.snfld.focus();
        },
        mounted() {
            setTimeout(() => {
                if (this.validWorker) {
                    if (this.validSO.so) {
                        if (this.$refs.snfld) this.$refs.snfld.focus();
                        if (this.$refs.sn2fld) this.$refs.sn2fld.focus();
                    } else
                    if (this.$refs.sofld) this.$refs.sofld.focus();
                } else {
                    if (this.$refs.wrkr) this.$refs.wrkr.focus();
                }
            }, 20)
        },
        watch: {
            lastResult: function () {
                this.$toasted.show(this.lastResult.msg, {
                    theme: "toasted-primary",
                    position: "top-center",
                    fullWidth: true,
                    duration: 3000,
                    type: this.lastResult.type
                });
            }

        },
        methods: {
            doneToInt(itemCode) {
                return parseInt(this.validSO.done[itemCode] ? this.validSO.done[itemCode] : 0);
            },
            remains(item) {
                return item.qtty - (item.qttyERP + this.doneToInt(item.itemCode));
            },
            invalidateWorker: function () {
                this.$store.commit('saveWorker', '');
                var self = this;
                Vue.nextTick(function () {
                    self.$refs.wrkr.select();
                })

            },
            validateWorker: function () {
                if (this.wrkr)
                    this.$store.commit('saveWorker', this.wrkr);
                var self = this;

                Vue.nextTick(function () {
                    if (self.$refs.sofld) self.$refs.sofld.focus();
                })
            },
            invalidateSO: function () {
                this.$store.commit('setSOdata', []);
                var self = this;
                Vue.nextTick(function () {
                    self.$refs.sofld.select();
                })

            },
            scanSO: function () {
                if (this.tmpSO.trim().length < 5) return;
                this.$store.dispatch('validateSO', this.tmpSO);
                this.tmpSO = '';
            },
            scanSN: function () {
                if (this.tmpSN.trim().length < 6) return;
                this.$store.dispatch('shipSN', {sn: this.tmpSN, so: this.validSO.so, wrkr: this.validWorker});
                this.tmpSN = '';
            },
            scanCSN: function() {
                if (this.CSN.trim().length < 2) return;
                if (this.validSO.pattern) {
                    var regex = new RegExp(this.validSO.pattern,'');
                    if (!this.CSN.match(regex)) {
                        this.CSN = '';
                        this.$store.commit('showMessage', { type: 'error', msg: 'Invalid Customer Number!'});
                        return;
                    }
                }
                this.$store.dispatch('assignCSN', { csn: this.CSN, sn: this.lastShipState.sn, customerName:this.lastShipState.customerName, so: this.validSO.so, wrkr: this.validWorker});
                this.CSN = '';
            },
            closeCSN: function() {
                this.tmpSN = '';
                this.CSN = '';
                this.$store.commit('setShipSNdata', null);

            }
        }
    }
</script>

<style scoped>
    .redbg {
        background-color: red;
    }
    .popup-bg {
        position: fixed;
        left:0; top:0; bottom: 0; right: 0;
        background-color: black;
        z-index: 10;
        opacity: 0.7;
    }
    .popup {
        position: fixed;
        z-index: 12;
        transform: translate(-50%, 0);
        max-width: 90%;
        background-color: white;
        width: 400px;
        box-shadow: 4px 4px 12px #222;
        top: 60px;
        left: 50%; height: 120px;
    }
    .form > DIV { margin: 5px 7px 5px 0;   }


    h4 {
        margin: 0
    }

    .form {
        display: flex;
        clear: both;
        align-items: center;
    }

    .flx {
        float: right;
        font-size: 20px;
        margin: -5px -10px;
    }

    .form > DIV {
        white-space: nowrap
    }

    .snlist {
        width: 100%;
        padding: 0;
        margin: 10px 0;
        list-style-type: none;
        border-collapse: collapse;
    }

    .snlist TD {
        border-bottom: solid 1px #ccc;
        padding: 2px;
    }

    .snlist THEAD TH {
        border-bottom: solid 2px #999
    }

    .bigger {
        font-size: 120%
    }

    .nula {
        font-size: 80%;
        color: #888
    }

    .grok {
        color: green
    }

    .notdone {
        color: red
    }

    TR.disabled {
        background-color: #bbb
    }

    TR.rowdone {
        background-color: #0c0
    }

    TR.disabled .notdone {
        color: inherit
    }
    .fr {
        float: right; margin:5px;
    }

</style>